// ═══════════════════════════════════════════════════════════════
//  THEME.JS — DBLA Sound
// ═══════════════════════════════════════════════════════════════

// ── Sticky nav ──
const nav = document.getElementById('nav');
if (nav) {
  window.addEventListener('scroll', () => {
    nav.classList.toggle('scrolled', window.scrollY > 60);
  }, { passive: true });
}

// ── Sélecteur de langue (nav + footer) ──
function initLangSwitcher(btnId, dropdownId) {
  const btn      = document.getElementById(btnId);
  const dropdown = document.getElementById(dropdownId);
  if (!btn || !dropdown) return;

  btn.addEventListener('click', (e) => {
    e.stopPropagation();
    const isOpen = dropdown.classList.contains('open');
    // Ferme tous les dropdowns langue ouverts
    document.querySelectorAll('.nav-lang-dropdown.open, .lang-switcher-dropdown.open')
      .forEach(d => { d.classList.remove('open'); });
    document.querySelectorAll('[id$="LangBtn"][aria-expanded="true"]')
      .forEach(b => b.setAttribute('aria-expanded', 'false'));

    if (!isOpen) {
      dropdown.classList.add('open');
      btn.setAttribute('aria-expanded', 'true');
    }
  });
}

document.addEventListener('click', () => {
  document.querySelectorAll('.nav-lang-dropdown.open, .lang-switcher-dropdown.open')
    .forEach(d => d.classList.remove('open'));
  document.querySelectorAll('[aria-expanded="true"][id$="LangBtn"]')
    .forEach(b => b.setAttribute('aria-expanded', 'false'));
});

initLangSwitcher('navLangBtn',    'navLangDropdown');
initLangSwitcher('footerLangBtn', 'footerLangDropdown');

// ── Mobile nav drawer ──
const hamburger  = document.getElementById('navHamburger');
const navDrawer  = document.getElementById('navDrawer');

function openMobileMenu() {
  if (!hamburger || !navDrawer) return;
  hamburger.classList.add('open');
  hamburger.setAttribute('aria-expanded', 'true');
  navDrawer.classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeMobileMenu() {
  if (!hamburger || !navDrawer) return;
  hamburger.classList.remove('open');
  hamburger.setAttribute('aria-expanded', 'false');
  navDrawer.classList.remove('open');
  document.body.style.overflow = '';
}
if (hamburger) {
  hamburger.addEventListener('click', () => {
    navDrawer.classList.contains('open') ? closeMobileMenu() : openMobileMenu();
  });
}
// Fermer si clic sur l'overlay du drawer mobile
if (navDrawer) {
  navDrawer.addEventListener('click', (e) => {
    if (e.target === navDrawer) closeMobileMenu();
  });
}

// ── ESC ferme tout ──
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    closeMobileMenu();
    closeCartDrawer();
    closeModal();
    closeInstallModal();
    closeFaqDrawer();
    stopAllAudio();
  }
});

// ═══════════════════════════════════════════════════════════════
//  CART DRAWER — AJAX
// ═══════════════════════════════════════════════════════════════

function formatMoney(cents) {
  return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
}

async function fetchCart() {
  const res = await fetch('/cart.js');
  if (!res.ok) throw new Error('Cart fetch failed');
  return res.json();
}

function updateCartBadge(count) {
  const badge = document.getElementById('cartBadge');
  if (!badge) return;
  if (count > 0) {
    badge.textContent = count > 99 ? '99+' : count;
    badge.classList.add('visible');
  } else {
    badge.classList.remove('visible');
  }
}

async function renderCartDrawer() {
  const body   = document.getElementById('cartDrawerBody');
  const footer = document.getElementById('cartDrawerFooter');
  const total  = document.getElementById('cartDrawerTotal');
  if (!body) return;

  try {
    const cart = await fetchCart();
    updateCartBadge(cart.item_count);

    if (cart.item_count === 0) {
      body.innerHTML = `
        <div class="cart-drawer-empty">
          <div class="cart-drawer-empty-icon">🛒</div>
          <p>Votre panier est vide</p>
          <a href="/collections/all" class="btn-primary" onclick="closeCartDrawer()" style="margin-top:16px;width:auto">
            Voir le catalogue
          </a>
        </div>`;
      if (footer) footer.style.display = 'none';
      return;
    }

    let html = '';
    for (const item of cart.items) {
      const imgSrc = item.image
        ? item.image.replace(/(\.[^.]+)$/, '_120x$1')
        : null;
      const variantLine = item.variant_title && item.variant_title !== 'Default Title'
        ? `<div class="cart-drawer-item-variant">${item.variant_title}</div>`
        : '';
      html += `
        <div class="cart-drawer-item">
          <div class="cart-drawer-item-img">
            ${imgSrc ? `<img src="${imgSrc}" alt="${item.title}" loading="lazy">` : '🔊'}
          </div>
          <div class="cart-drawer-item-info">
            <div class="cart-drawer-item-title">${item.product_title}</div>
            ${variantLine}
            <div class="cart-drawer-item-price">${formatMoney(item.price)}</div>
          </div>
          <div class="cart-drawer-item-actions">
            <div class="cart-drawer-item-qty">
              <button class="qty-btn" onclick="updateCartItem('${item.key}', ${item.quantity - 1})">−</button>
              <span>${item.quantity}</span>
              <button class="qty-btn" onclick="updateCartItem('${item.key}', ${item.quantity + 1})">+</button>
            </div>
            <button class="cart-drawer-item-remove" onclick="updateCartItem('${item.key}', 0)" title="Supprimer">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="3 6 5 6 21 6"/>
                <path d="M19 6l-1 14H6L5 6"/>
                <path d="M10 11v6M14 11v6M9 6V4h6v2"/>
              </svg>
            </button>
          </div>
        </div>`;
    }

    body.innerHTML = html;
    if (total) total.textContent = formatMoney(cart.total_price);
    if (footer) footer.style.display = 'block';

  } catch (err) {
    body.innerHTML = `<div class="cart-drawer-empty"><p style="color:var(--clr-muted)">Erreur de chargement. <a href="/cart" style="color:var(--clr-accent)">Voir le panier</a></p></div>`;
  }
}

async function updateCartItem(key, quantity) {
  try {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
    });
    renderCartDrawer();
  } catch {
    // silently fail — drawer will show stale data
  }
}

function openCartDrawer() {
  const drawer  = document.getElementById('cartDrawer');
  const overlay = document.getElementById('cartOverlay');
  if (!drawer) return;
  drawer.classList.add('open');
  if (overlay) overlay.classList.add('open');
  document.body.style.overflow = 'hidden';
  renderCartDrawer();
}

function closeCartDrawer() {
  const drawer  = document.getElementById('cartDrawer');
  const overlay = document.getElementById('cartOverlay');
  if (!drawer) return;
  drawer.classList.remove('open');
  if (overlay) overlay.classList.remove('open');
  document.body.style.overflow = '';
}

// Bouton panier dans le header
document.addEventListener('DOMContentLoaded', () => {
  const cartBtn = document.getElementById('cartBtn');
  if (cartBtn) cartBtn.addEventListener('click', openCartDrawer);

  // Init badge au chargement
  fetchCart().then(cart => updateCartBadge(cart.item_count)).catch(() => {});
});

// ── Add to cart — page produit ──
const productForm = document.getElementById('product-form');
if (productForm) {
  productForm.addEventListener('submit', async (e) => {
    e.preventDefault();
    const btn  = productForm.querySelector('[type="submit"]');
    const orig = btn.innerHTML;
    btn.innerHTML = '<span style="display:inline-block;animation:spin 0.6s linear infinite;border:2px solid rgba(255,255,255,0.3);border-top-color:#fff;border-radius:50%;width:16px;height:16px;"></span>';
    btn.disabled = true;
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(productForm)
      });
      if (!res.ok) throw new Error();
      btn.innerHTML = '✓ Ajouté au panier';
      btn.classList.add('success');
      openCartDrawer();
      setTimeout(closeCartDrawer, 3500);
      setTimeout(() => { btn.innerHTML = orig; btn.classList.remove('success'); btn.disabled = false; }, 2500);
    } catch {
      btn.innerHTML = 'Erreur — réessayez';
      btn.style.background = '#ef4444';
      setTimeout(() => { btn.innerHTML = orig; btn.style.background = ''; btn.disabled = false; }, 2500);
    }
  });
}

// ── Add to cart — depuis une card produit ──
async function addToCartFromCard(variantId, btn) {
  if (!variantId) return;
  const orig = btn.innerHTML;
  btn.innerHTML = '···';
  btn.disabled = true;
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    });
    if (!res.ok) throw new Error();
    btn.innerHTML = '✓ Ajouté !';
    btn.classList.add('success');
    openCartDrawer();
    setTimeout(closeCartDrawer, 3500);
    setTimeout(() => { btn.innerHTML = orig; btn.classList.remove('success'); btn.disabled = false; }, 2200);
  } catch {
    btn.innerHTML = 'Erreur';
    btn.classList.add('error');
    setTimeout(() => { btn.innerHTML = orig; btn.classList.remove('error'); btn.disabled = false; }, 2200);
  }
}

// ═══════════════════════════════════════════════════════════════
//  BRAND TABS — Drag to scroll (desktop)
// ═══════════════════════════════════════════════════════════════
const brandTabsEl = document.getElementById('brandTabs');
if (brandTabsEl) {
  let isDown = false, startX, scrollLeft;

  brandTabsEl.addEventListener('mousedown', (e) => {
    isDown = true;
    brandTabsEl.classList.add('is-grabbing');
    startX = e.pageX - brandTabsEl.offsetLeft;
    scrollLeft = brandTabsEl.scrollLeft;
  });
  brandTabsEl.addEventListener('mouseleave', () => { isDown = false; brandTabsEl.classList.remove('is-grabbing'); });
  brandTabsEl.addEventListener('mouseup',    () => { isDown = false; brandTabsEl.classList.remove('is-grabbing'); });
  brandTabsEl.addEventListener('mousemove',  (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - brandTabsEl.offsetLeft;
    brandTabsEl.scrollLeft = scrollLeft - (x - startX) * 1.5;
  });
  // Molette → scroll horizontal (uniquement si les tabs débordent)
  brandTabsEl.addEventListener('wheel', (e) => {
    if (brandTabsEl.scrollWidth > brandTabsEl.clientWidth + 2) {
      e.preventDefault();
      brandTabsEl.scrollLeft += e.deltaY;
    }
  }, { passive: false });
}

// ── Brand filter tabs ──
const tabs         = document.querySelectorAll('.brand-tab');
const cards        = document.querySelectorAll('.product-card');
const productsGrid = document.getElementById('productsGrid');

function applyBrandFilter(brand) {
  cards.forEach(card => {
    let show;
    if (brand === 'bestseller') {
      const badge = (card.dataset.badge || '').toLowerCase();
      show = badge.includes('best');
    } else {
      show = card.dataset.brand === brand;
    }
    card.classList.toggle('visible', show);
  });
  if (productsGrid) productsGrid.scrollLeft = 0;
}

tabs.forEach(tab => {
  tab.addEventListener('click', () => {
    tabs.forEach(t => t.classList.remove('active'));
    tab.classList.add('active');
    applyBrandFilter(tab.dataset.brand);
  });
});

// Appliquer le filtre actif au chargement de la page
const initTab = document.querySelector('.brand-tab.active');
if (initTab) applyBrandFilter(initTab.dataset.brand);

// ═══════════════════════════════════════════════════════════════
//  MODAL PRODUIT
// ═══════════════════════════════════════════════════════════════
function openModal(card) {
  const overlay = document.getElementById('modalOverlay');
  if (!overlay) return;

  document.getElementById('modalBrand').textContent  = card.dataset.brand || '';
  document.getElementById('modalName').textContent   = card.dataset.name  || '';
  document.getElementById('modalDesc').textContent   = card.dataset.desc  || '';
  document.getElementById('modalPrice').textContent  = card.dataset.priceFormatted || (card.dataset.price + '€ TTC');

  const modalImg         = document.getElementById('modalImage');
  const modalPlaceholder = document.getElementById('modalPlaceholder');
  if (card.dataset.image && card.dataset.image !== '') {
    if (modalImg) { modalImg.src = card.dataset.image; modalImg.style.display = 'block'; }
    if (modalPlaceholder) modalPlaceholder.style.display = 'none';
  } else {
    if (modalImg) modalImg.style.display = 'none';
    if (modalPlaceholder) modalPlaceholder.style.display = 'flex';
  }

  const modalBtn = document.getElementById('modalProductLink');
  if (modalBtn && card.dataset.url) modalBtn.href = card.dataset.url;

  overlay.classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeModal() {
  const overlay = document.getElementById('modalOverlay');
  if (!overlay) return;
  overlay.classList.remove('open');
  document.body.style.overflow = '';
}
function closeModalIfOverlay(e) {
  if (e.target === document.getElementById('modalOverlay')) closeModal();
}

// ── Modal installation ──
function openInstallModal() {
  const overlay = document.getElementById('installOverlay');
  if (!overlay) return;
  overlay.classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeInstallModal() {
  const overlay = document.getElementById('installOverlay');
  if (!overlay) return;
  overlay.classList.remove('open');
  document.body.style.overflow = '';
}

// ═══════════════════════════════════════════════════════════════
//  GALERIE PRODUIT
// ═══════════════════════════════════════════════════════════════
function switchProductImage(thumb, src) {
  const main = document.getElementById('mainProductImg');
  if (main) main.src = src;
  document.querySelectorAll('.product-thumb-item').forEach(t => t.classList.remove('active'));
  thumb.classList.add('active');
}

// ── Quantité produit ──
function changeQty(delta) {
  const input = document.getElementById('qtyInput');
  if (!input) return;
  input.value = Math.max(1, Math.min(10, parseInt(input.value || 1) + delta));
}

// ── Variante produit ──
function selectVariant(variantId, price, btn) {
  const idField = document.getElementById('variantId');
  if (idField) idField.value = variantId;
  // Sync le formulaire de paiement rapide (Apple Pay / Shop Pay)
  const dynamicIdField = document.getElementById('dynamicVariantId');
  if (dynamicIdField) dynamicIdField.value = variantId;
  const priceEl = document.querySelector('.product-price-main');
  if (priceEl) {
    priceEl.innerHTML = (price / 100).toFixed(2).replace('.', ',') + ' €<span>TTC</span>';
  }
  document.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
}

// ═══════════════════════════════════════════════════════════════
//  FAQ ACCORDION
// ═══════════════════════════════════════════════════════════════
function toggleFaq(btn) {
  const item   = btn.closest('.faq-item');
  const isOpen = item.classList.contains('open');
  document.querySelectorAll('.faq-item.open').forEach(i => i.classList.remove('open'));
  if (!isOpen) item.classList.add('open');
}

// ═══════════════════════════════════════════════════════════════
//  MODES AUDIO
// ═══════════════════════════════════════════════════════════════
let currentAudio = null;
let currentCard  = null;

function stopAllAudio() {
  if (currentAudio) { currentAudio.pause(); currentAudio.currentTime = 0; currentAudio = null; }
  if (currentCard)  { currentCard.classList.remove('playing'); currentCard = null; }
}

function toggleAudioMode(card) {
  const src = card.dataset.audioSrc;
  // Si cette card était déjà en lecture, on stop
  if (currentCard === card) { stopAllAudio(); return; }
  // Sinon on stop l'audio précédent et on lance le nouveau
  stopAllAudio();
  if (src && src !== '') {
    const audio = new Audio(src);
    audio.loop  = true;
    audio.volume = 0.8;
    audio.play().then(() => {
      currentAudio = audio;
      currentCard  = card;
      card.classList.add('playing');
      audio.addEventListener('ended', () => { card.classList.remove('playing'); currentAudio = null; currentCard = null; });
    }).catch(() => {
      // Autoplay bloqué ou fichier manquant — on indique quand même l'état visuel
      card.classList.add('playing');
      currentCard = card;
    });
  } else {
    // Pas de fichier audio configuré → démonstration visuelle uniquement
    card.classList.add('playing');
    currentCard = card;
  }
}

// ═══════════════════════════════════════════════════════════════
//  TESTIMONIALS CAROUSEL
// ═══════════════════════════════════════════════════════════════
(function initTestimonialsCarousel() {
  const carousel = document.getElementById('testimonialsCarousel');
  if (!carousel) return;

  const slides = carousel.querySelectorAll('.testimonial-card');
  const dots   = document.querySelectorAll('.testimonials-dot');
  let current  = 0;
  let perPage  = getPerPage();
  let total    = Math.ceil(slides.length / perPage);
  let timer;

  function getPerPage() {
    if (window.innerWidth <= 600) return 1;
    if (window.innerWidth <= 900) return 2;
    return 3;
  }

  function goTo(index) {
    current = ((index % total) + total) % total;
    const offset = current * perPage;
    const slideWidth = carousel.parentElement.offsetWidth;
    carousel.style.transform = `translateX(-${current * (slideWidth + 24)}px)`;
    dots.forEach((d, i) => d.classList.toggle('active', i === current));
  }

  function autoPlay() {
    timer = setInterval(() => goTo(current + 1), 5500);
  }
  function stopPlay() { clearInterval(timer); }

  document.querySelector('.testimonials-prev')?.addEventListener('click', () => { stopPlay(); goTo(current - 1); autoPlay(); });
  document.querySelector('.testimonials-next')?.addEventListener('click', () => { stopPlay(); goTo(current + 1); autoPlay(); });
  dots.forEach((dot, i) => dot.addEventListener('click', () => { stopPlay(); goTo(i); autoPlay(); }));

  // Recalcul au resize
  window.addEventListener('resize', () => {
    const newPerPage = getPerPage();
    if (newPerPage !== perPage) { perPage = newPerPage; total = Math.ceil(slides.length / perPage); goTo(0); }
  }, { passive: true });

  goTo(0);
  autoPlay();
})();

// ═══════════════════════════════════════════════════════════════
//  SCROLL REVEAL
// ═══════════════════════════════════════════════════════════════
const reveals = document.querySelectorAll('.reveal');
if (reveals.length) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry, i) => {
      if (entry.isIntersecting) {
        setTimeout(() => entry.target.classList.add('visible'), i * 80);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });
  reveals.forEach(el => observer.observe(el));
}

// ═══════════════════════════════════════════════════════════════
//  GALERIE PRODUIT — swipe mobile + navigation
// ═══════════════════════════════════════════════════════════════
let galleryIndex = 0;

function galleryGoTo(index) {
  const thumbs = document.querySelectorAll('.product-thumb-item');
  if (thumbs.length === 0) return;

  galleryIndex = ((index % thumbs.length) + thumbs.length) % thumbs.length;
  const active = thumbs[galleryIndex];

  // Changer l'image principale
  const mainImg = document.getElementById('mainProductImg');
  if (mainImg && active) {
    mainImg.style.opacity = '0.4';
    mainImg.src = active.dataset.full || active.querySelector('img')?.src || mainImg.src;
    mainImg.alt = active.dataset.alt || '';
    mainImg.onload = () => { mainImg.style.opacity = '1'; };
    if (mainImg.complete && mainImg.src) mainImg.style.opacity = '1';
  }

  // Thumbnail active
  thumbs.forEach((t, i) => t.classList.toggle('active', i === galleryIndex));

  // Counter
  const counter = document.getElementById('galleryCounter');
  if (counter) counter.textContent = (galleryIndex + 1) + ' / ' + thumbs.length;

  // Dots
  document.querySelectorAll('.gallery-dot').forEach((d, i) =>
    d.classList.toggle('active', i === galleryIndex)
  );

  // Scroll thumb into view (desktop)
  if (active) active.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
}

function galleryGo(dir) {
  const thumbs = document.querySelectorAll('.product-thumb-item');
  if (thumbs.length < 2) return;
  galleryGoTo(galleryIndex + dir);
}

// Touch swipe sur l'image principale
(function () {
  const mainEl = document.getElementById('productGalleryMain');
  if (!mainEl) return;
  let startX = 0, startY = 0;
  mainEl.addEventListener('touchstart', function(e) {
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
  }, { passive: true });
  mainEl.addEventListener('touchend', function(e) {
    const dx = e.changedTouches[0].clientX - startX;
    const dy = Math.abs(e.changedTouches[0].clientY - startY);
    if (Math.abs(dx) > 40 && dy < 80) galleryGo(dx > 0 ? -1 : 1);
  }, { passive: true });
})();

// ═══════════════════════════════════════════════════════════════
//  FAQ DRAWER — page produit
// ═══════════════════════════════════════════════════════════════
function openFaqDrawer() {
  const drawer  = document.getElementById('faqDrawer');
  const overlay = document.getElementById('faqDrawerOverlay');
  if (!drawer) return;
  drawer.classList.add('open');
  if (overlay) overlay.classList.add('visible');
  document.body.style.overflow = 'hidden';
}

function closeFaqDrawer() {
  const drawer  = document.getElementById('faqDrawer');
  const overlay = document.getElementById('faqDrawerOverlay');
  if (!drawer) return;
  drawer.classList.remove('open');
  if (overlay) overlay.classList.remove('visible');
  document.body.style.overflow = '';
}

function toggleFaqDrawerItem(btn) {
  const item = btn.closest('.faq-drawer-item');
  if (!item) return;
  const isOpen = item.classList.contains('open');
  // Fermer tous les autres
  const body = item.closest('.faq-drawer-body');
  if (body) {
    body.querySelectorAll('.faq-drawer-item.open').forEach(function(i) {
      i.classList.remove('open');
      const t = i.querySelector('.faq-drawer-item-trigger');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  }
  if (!isOpen) {
    item.classList.add('open');
    btn.setAttribute('aria-expanded', 'true');
  }
}

// ═══════════════════════════════════════════════════════════════
//  MODES AUDIO PRODUIT — accordéon
// ═══════════════════════════════════════════════════════════════
function toggleProductAudio() {
  const btn     = document.getElementById('productAudioTrigger');
  const content = document.getElementById('productAudioContent');
  if (!btn || !content) return;
  const isOpen = content.classList.contains('open');
  content.classList.toggle('open', !isOpen);
  btn.setAttribute('aria-expanded', String(!isOpen));
}

// ═══════════════════════════════════════════════════════════════
//  PRODUITS RECOMMANDÉS — carousel
// ═══════════════════════════════════════════════════════════════
(function () {
  const carousel = document.getElementById('recsCarousel');
  if (!carousel) return;

  const cards = carousel.querySelectorAll('.rec-card');
  if (cards.length === 0) return;

  let recsIdx = 0;

  function getPerPage() { return window.innerWidth >= 768 ? 4 : 2; }
  function getGap()     { return 16; }
  function getCardW()   { return (cards[0] && cards[0].offsetWidth + getGap()) || 0; }
  function getMax()     { return Math.max(0, cards.length - getPerPage()); }

  window.recsGo = function (dir) {
    recsIdx = Math.max(0, Math.min(getMax(), recsIdx + dir));
    carousel.style.transform = 'translateX(-' + (recsIdx * getCardW()) + 'px)';
  };

  window.addEventListener('resize', function () { recsIdx = 0; carousel.style.transform = 'translateX(0)'; }, { passive: true });
})();

// ═══════════════════════════════════════════════════════════════
//  RETOUR EN HAUT
// ═══════════════════════════════════════════════════════════════
(function () {
  const btn = document.getElementById('backToTop');
  if (!btn) return;
  window.addEventListener('scroll', function () {
    btn.classList.toggle('visible', window.scrollY > 400);
  }, { passive: true });
  btn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();


// ═══════════════════════════════════════════════════════════════
//  PAGE LOADER
// ═══════════════════════════════════════════════════════════════
(function () {
  var loader = document.getElementById('page-loader');
  if (!loader) return;
  // CSS handles the reduced-motion case (display:none), but double-guard in JS
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    loader.classList.add('hidden');
    return;
  }
  // bar animation: 0.45s delay + 0.85s fill = 1.3s total — hide just after
  function hideLoader() {
    loader.classList.add('hidden');
    // Remove from DOM after transition finishes (0.55s)
    setTimeout(function () {
      if (loader && loader.parentNode) loader.parentNode.removeChild(loader);
    }, 650);
  }
  if (document.readyState === 'complete') {
    setTimeout(hideLoader, 250);
  } else {
    window.addEventListener('load', function () { setTimeout(hideLoader, 250); });
  }
})();

// ═══════════════════════════════════════════════════════════════
//  SCROLL PROGRESS BAR
// ═══════════════════════════════════════════════════════════════
(function () {
  var bar = document.getElementById('scroll-progress');
  if (!bar) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  window.addEventListener('scroll', function () {
    var scrolled = window.scrollY;
    var total = document.documentElement.scrollHeight - window.innerHeight;
    bar.style.width = total > 0 ? Math.min(100, (scrolled / total) * 100) + '%' : '0%';
  }, { passive: true });
})();

// ═══════════════════════════════════════════════════════════════
//  HERO PARALLAX — content drifts slightly on scroll
// ═══════════════════════════════════════════════════════════════
(function () {
  var heroContent = document.querySelector('.hero-content');
  if (!heroContent) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var y = window.scrollY;
      var vh = window.innerHeight;
      if (y < vh * 1.2) {
        var drift = y * 0.18;
        var fade  = Math.max(0, 1 - (y / (vh * 0.8)));
        heroContent.style.transform = 'translateY(' + drift + 'px)';
        heroContent.style.opacity   = fade;
      }
      ticking = false;
    });
  }, { passive: true });
})();
